import { render } from "./indexParent.vue?vue&type=template&id=af632b38&scoped=true"
import script from "./indexParent.vue?vue&type=script&lang=js"
export * from "./indexParent.vue?vue&type=script&lang=js"

import "./indexParent.vue?vue&type=style&index=0&id=af632b38&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af632b38"]])

export default __exports__